import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sheet-sign",
  "use": "sheet-sign-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol viewBox=\"0 0 10 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"sheet-sign\">\n<path d=\"M5.75258 5.13991L9.5244 0.829253C9.80728 0.505961 9.5777 0 9.14812 0L0.851884 0C0.422305 0 0.192716 0.505961 0.475596 0.829253L4.24742 5.13991C4.64583 5.59524 5.35417 5.59524 5.75258 5.13991Z\" fill=\"#C1C1C1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol